import React, { useState, useEffect } from "react";
import CardForAllData from "components/Cards/CardForAllData";
import BASE_URL from "components/BaseUrl/apiConfig";

function AllTypeOfMsgCount() {
  const [messageCounts, setMessageCounts] = useState({
    TotalMessages: 0,
    Email: 0,
    Facebook: 0,
    LinkedIn: 0,
    Others: 0,
  });

  useEffect(() => {
    const storedUserData = localStorage.getItem("userData");
    let groupId = "";

    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      groupId = userData.groupId;
    }

    const fetchData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Analytics/GetAllMessageCounts?groupId=${groupId}`
        );
        const result = await response.json();
        console.log("Fetched message counts:", result); // Log the fetched result
        setMessageCounts(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (groupId) {
      fetchData();
    }
  }, []);

  return (
    <div className="relative md:pt-8 pb-16 mt-4">
      <div className="mx-auto w-full">
        {/* Card stats */}
        <div className="flex flex-wrap">
          <CardForAllData
            statSubtitle=""
            statTitle={`Total Messages: ${messageCounts.TotalMessages}`}
            statPercentColor="text-emerald-500"
            statIconName="fas fa-envelope"
            statIconColor="bg-red-500"
          >
            <div className="mt-4">
              <p>Email : {messageCounts.Email}</p>
              <p>Facebook : {messageCounts.Facebook}</p>
              <p>LinkedIn : {messageCounts.LinkedIn}</p>
              <p>Others : {messageCounts.Others}</p>
            </div>
          </CardForAllData>
        </div>
      </div>
    </div>
  );
}

export default AllTypeOfMsgCount;
